var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"personalcenter-content"},[_c('personal-center',{attrs:{"img-click":_vm.imgClicks,"blue":'#c8161d'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }